import PropTypes from "prop-types";
import { Empty, Spin } from "antd";
import cn from "../../../utilities/tailwind-merge";
import CarCard from "./CarCard";

function CarListCards({ cars, loading, t, isCarPricingMode, actionItems, onActionClick }) {
    if (loading && cars.length === 0) {
        return (
            <div className="flex min-h-[200px] items-center justify-center">
                <Spin />
            </div>
        );
    }

    if (!loading && cars.length === 0) {
        return (
            <div className="py-10">
                <Empty description={t("noCars")} image={Empty.PRESENTED_IMAGE_SIMPLE} />
            </div>
        );
    }

    return (
        <div className="relative min-h-[120px]">
            {loading ? (
                <div
                    className="absolute inset-0 z-10 flex items-center justify-center rounded-xl bg-white/70"
                    aria-busy="true"
                    aria-live="polite">
                    <Spin />
                </div>
            ) : null}
            <div
                className={cn("flex flex-col gap-3", loading && "pointer-events-none select-none opacity-50")}
                aria-hidden={loading}>
                {cars.map((car) => (
                    <CarCard
                        key={car.id || car.VIN}
                        car={car}
                        t={t}
                        isCarPricingMode={isCarPricingMode}
                        actionItems={actionItems}
                        onActionClick={onActionClick}
                    />
                ))}
            </div>
        </div>
    );
}

CarListCards.propTypes = {
    cars: PropTypes.arrayOf(PropTypes.object).isRequired,
    loading: PropTypes.bool.isRequired,
    t: PropTypes.func.isRequired,
    isCarPricingMode: PropTypes.bool.isRequired,
    actionItems: PropTypes.arrayOf(PropTypes.object).isRequired,
    onActionClick: PropTypes.func.isRequired,
};

export default CarListCards;
